import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getEndUserDetails } from '../api';
import {
  getLocalStorageData,
  logOut,
} from '../common/resubale-functions';
import { MainContext } from './context/context';
import mixpanel from 'mixpanel-browser';
import { bankpay_consumer_user_id } from '../common/constants';

const Menu = (props) => {
  const history = useHistory();
  const context = useContext(MainContext);
  const {
    loginTokenContext,
    setLOginTokenContext,
    userIdContext,
    setUserIdContext,
    setUserLogoContext,
    userLogoContext,
    setPath,
  } = context;
  const [userDetais, setUserDetails] = useState({});
  const [userIcon, setUserIcon] = useState('');
  var event_sent = false;

  useEffect(() => {
    setPath(window.location.pathname);
  }, [window.location.pathname]);

  useEffect(() => {
    if (loginTokenContext && userIdContext) {
      getuserDetails();
    }
  }, [loginTokenContext, userIdContext]);

  const handleLogout = () => {
    mixpanel.track("Logged Out", {
      distinct_id: getLocalStorageData(bankpay_consumer_user_id, 'string'),
      touch_point: "consumer web",
    },
    {send_immediately: true}
  );
    logOut();
    setLOginTokenContext('');
    setUserIdContext('');
    history.push('/');
  };

  useEffect(() => {
    document.title = 'Account';
  }, [])

  const getuserDetails = async () => {
    const res = await getEndUserDetails(userIdContext);
    setUserDetails(res?.data?.data);
    if (!event_sent) {
      event_sent = true
      mixpanel.track("Viewed Account Page", {
          distinct_id: getLocalStorageData(bankpay_consumer_user_id, 'string'),
          touch_point: "consumer web",
        },
        {send_immediately: true}
      );
    }
  };

  const sendEvent = () => {
    mixpanel.track("Clicked Contact Support", {
      distinct_id: getLocalStorageData(bankpay_consumer_user_id, 'string'),
      touch_point: "consumer web",
      button_location: 'account_page',
    },
    {send_immediately: true}
  );
  }
  return (
    <>
      {userDetais && userDetais.user_detail ?
        <div className="orders-detail-page md:max-w-[340px] mx-auto py-5 flex flex-col lg:h-full">
          <div className="orders-detail-page-inner h-full">
            <div className="h-full flex flex-col lg:overflow-auto">
              <div className="page-title text-[32px] font-Rany font-bold grow-0 shrink-0 flex gap-4 items-center  pb-2 lg:pt-0">
                My Account
              </div>
              <div className="flex gap-6 lg:overflow-auto flex-col">
                <div className="orders-view-box w-full">
                  <div className="orders-view-box-bottom">
                    <div className="flex gap-4 mt-2 items-center justify-between">
                      <div className="orders-view-box-bottom-left shrink-0 flex gap-2 items-center">
                        <div>
                          <span className="text-2xl text-[#0F0F0F] font-Rany font-bold leading-none">
                            {userDetais.user_detail.first_name} {userDetais.user_detail.last_name}
                          </span>
                          <div className="text-base font-Rany text-[#A8BAC9]">
                            {userDetais.phone_number}
                          </div>
                        </div>
                      </div>
                    </div>

                    <a href="mailto:support@joinfam.com" onClick={sendEvent}>
                      <div className="my-4 flex gap-2 justify-between items-center cursor-pointer">
                        <div className="text-base font-Rany text-[#0f0f0f] leading-tight flex gap-2 items-center ">
                          <svg className=" text-[#0F0F0F] w-4 h-4" width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.625 9C6.625 9.09946 6.58549 9.19484 6.51517 9.26517C6.44484 9.33549 6.34946 9.375 6.25 9.375C6.15054 9.375 6.05516 9.33549 5.98484 9.26517C5.91451 9.19484 5.875 9.09946 5.875 9C5.875 8.90054 5.91451 8.80516 5.98484 8.73483C6.05516 8.66451 6.15054 8.625 6.25 8.625C6.34946 8.625 6.44484 8.66451 6.51517 8.73483C6.58549 8.80516 6.625 8.90054 6.625 9ZM6.625 9H6.25M10.375 9C10.375 9.09946 10.3355 9.19484 10.2652 9.26517C10.1948 9.33549 10.0995 9.375 10 9.375C9.90054 9.375 9.80516 9.33549 9.73483 9.26517C9.66451 9.19484 9.625 9.09946 9.625 9C9.625 8.90054 9.66451 8.80516 9.73483 8.73483C9.80516 8.66451 9.90054 8.625 10 8.625C10.0995 8.625 10.1948 8.66451 10.2652 8.73483C10.3355 8.80516 10.375 8.90054 10.375 9ZM10.375 9H10M14.125 9C14.125 9.09946 14.0855 9.19484 14.0152 9.26517C13.9448 9.33549 13.8495 9.375 13.75 9.375C13.6505 9.375 13.5552 9.33549 13.4848 9.26517C13.4145 9.19484 13.375 9.09946 13.375 9C13.375 8.90054 13.4145 8.80516 13.4848 8.73483C13.5552 8.66451 13.6505 8.625 13.75 8.625C13.8495 8.625 13.9448 8.66451 14.0152 8.73483C14.0855 8.80516 14.125 8.90054 14.125 9ZM14.125 9H13.75M19 9C19 13.556 14.97 17.25 10 17.25C9.13718 17.251 8.27804 17.1377 7.445 16.913C6.27076 17.7389 4.83833 18.1141 3.41 17.97C3.25119 17.9547 3.09307 17.933 2.936 17.905C3.42887 17.3241 3.76547 16.6272 3.914 15.88C4.004 15.423 3.781 14.979 3.447 14.654C1.93 13.178 1 11.189 1 9C1 4.444 5.03 0.75 10 0.75C14.97 0.75 19 4.444 19 9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          Contact Support
                        </div>
                        <div className=" text-sm text-[#A8BAC9] flex gap-1 items-center justify-end">
                          <svg className=" text-[#0f0f0f]  w-3 h-3" width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 8.00003C8 8.28678 7.90396 8.5735 7.71229 8.79212L1.67776 15.6718C1.29388 16.1094 0.671503 16.1094 0.287787 15.6718C-0.095929 15.2343 -0.0959291 14.5249 0.287787 14.0872L5.62748 8.00003L0.287973 1.91279C-0.0957432 1.47515 -0.0957432 0.765812 0.287973 0.328388C0.671689 -0.109461 1.29407 -0.109461 1.67794 0.328388L7.71248 7.20793C7.90418 7.42666 8 7.71338 8 8.00003Z" fill="currentColor" />
                          </svg>
                        </div>
                      </div>
                    </a>
                    <a onClick={handleLogout} href="#" className="font-Rany text-base text-[#EA2B1F] hover:underline">
                      Log out
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> : ''}
    </>
  );
};

export default Menu;
